import { axiosCore } from './http-core-service';
import { ReferenceExterneDto } from './dtos/reference-externe.dto';
import { InterlocutorsReferenceExterneDto } from './dtos/interlocutors-reference-externe.dto';

/**
 * Méthode qui permet de récupérer les civilités
 * @return les civilites
 */
export const getCivilities = async (): Promise<ReferenceExterneDto[]> => {
    const response = await axiosCore.get('/civilites');
    return response.data['hydra:member'];
};

/**
 * Méthode qui permet de récupérer une civilité en fonction d'un ID
 * @param id identifiant de la civilité
 */
export const getCivilityById = async (id: string): Promise<ReferenceExterneDto> => {
    const response = await axiosCore.get('/civilites/' + id);
    return response.data;
};

/**
 * Méthode qui permet de récupérer les types d'interlocuteurs
 * @return les type d'interlocuteurs
 */
export const getInterlocutorsTypes = async (): Promise<InterlocutorsReferenceExterneDto[]> => {
    const response = await axiosCore.get('/interlocuteur_types');
    return response.data['hydra:member'];
};

/**
 * Méthode qui permet de récupérer un type d'interlocuteur en fonction d'un ID
 * @param id identifiant du type d'interlocuteur
 */
export const getInterlocutorsTypesById = async (id: string): Promise<InterlocutorsReferenceExterneDto> => {
    const response = await axiosCore.get('/interlocuteur_types/' + id);
    return response.data;
};
